import type { FaireProductEntity } from "../../entity_types/product";

export const p_a53rgmy2fw: FaireProductEntity = {
  token: "p_a53rgmy2fw",
  type: "product",
  name: "BARRY",
  brandToken: "b_8rgv5suw2a",
  brandName: "Portrait Coffee",
  imageUrl: "https://cdn.faire.com/fastly/36c7435ff2c08bc93922d96c1fb0a33d50578bebfd94273b8576860ab47b04ac.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2784638d5672a82e1553dfa0ea3d90694627ef41a8fba6a38b8180b770e97bbc.jpeg",
    "https://cdn.faire.com/fastly/5b6e0decf1bb99a9166276ef3d54571ba25415ef091c079e875789f6c09d259c.png",
    "https://cdn.faire.com/fastly/91b66ae31aae5feb413e5c3997a063b55bbdbb1a1e733cdaf81fc1ce009b5526.png"
  ],
  priceDollars: 10.05,
  description: "Well-Balanced, Sweet, Fruity\n\nA film-festival favorite in coffee form. Smooth, layered, and built for the second cup.\n\nTasting Notes: Crisp cherry, brown sugar, green apple\nFeatured Coffee: Rwanda Humure (rotating)\nRegion: Remera Sector, Gatsibo District, Eastern Province, Rwanda\nVariety: Red Bourbon\nAltitude: 1,500 to 1,900 masl\nProcess: Washed\nRoast Level: Medium\nRecommended Brew: Drip, pour-over, or espresso\n\nBarry is named for Oscar-winning director Barry Jenkins, an award-winning filmmaker whose work (Moonlight, If Beale Street Could Talk) has reshaped how American cinema sees Black life. The coffee is well-balanced and sweet, with a fruity edge that opens up across the cup. Crisp cherry on the front, brown sugar in the middle, green apple on the finish.\n\nWhole bean or ground, roasted to order in Atlanta. Available in 310 g, 2 lb, and 5 lb.\n",
  tags: [],
  msrpDollars: 16.75,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:46.289Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
